import { render, staticRenderFns } from "./PatientTray.vue?vue&type=template&id=2312d9cd&scoped=true&"
import script from "./PatientTray.vue?vue&type=script&lang=js&"
export * from "./PatientTray.vue?vue&type=script&lang=js&"
import style0 from "./PatientTray.vue?vue&type=style&index=0&id=2312d9cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2312d9cd",
  null
  
)

export default component.exports